import { Adresa } from './adresa';
import { KatastralneUzemie } from './katastralne-uzemie';

/**
 * 
 * @export
 * @interface ProjektLokalita
 */
export interface ProjektLokalita {
    /**
     * 
     * @type {Adresa}
     * @memberof ProjektLokalita
     */
    'adresa'?: Adresa;
    /**
     * 
     * @type {KatastralneUzemie}
     * @memberof ProjektLokalita
     */
    'katastralneUzemie'?: KatastralneUzemie;
    /**
     * 
     * @type {string}
     * @memberof ProjektLokalita
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjektLokalita
     */
    'parcelneCislo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjektLokalita
     */
    'poradie'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjektLokalita
     */
    'rola'?: ProjektLokalitaRolaEnum;
}

export const ProjektLokalitaRolaEnum = {
    LokalitaRealizacie: 'LOKALITA_REALIZACIE',
    PrimarnaLokalitaRealizacie: 'PRIMARNA_LOKALITA_REALIZACIE'
} as const;

export type ProjektLokalitaRolaEnum = typeof ProjektLokalitaRolaEnum[keyof typeof ProjektLokalitaRolaEnum];


